import FormaPagamentoService from "@/services/FormaPagamentoService";
import { router } from "@/router";
import Helper from "@/helper";

export const actions = {
  cadastrarFormaPagamento: ({ commit }) => {
    commit("setFormaPagamento", {});
    router.push({ name: "formaPagamentoCadastro" });
  },
  listarFormaPagamento: ({ commit }) => {
    commit("setOverlay", true);
    FormaPagamentoService.listar()
      .then((res) => {
        commit("setOverlay", false);
        commit("setFormasPagamento", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  salvarFormaPagamento: ({ commit }, data) => {
    commit("setOverlay", true);
    FormaPagamentoService.salvar(data)
      .then((res) => {
        commit("setOverlay", false);
        router.push({ name: "formaPagamentoEditar", params: { id: res.data.id } });
        commit("snackbarSuccess", "Forma de pagamento cadastrado.");
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar forma de pagamento.");
      });
  },
  async editarFormaPagamento({ commit }, id) {
    commit("setOverlay", true);
    await FormaPagamentoService.editar(id)
      .then((res) => {
        const formaPagamento = res.data;
        formaPagamento.acrescimo = res.data.acrescimo
          ? Helper.formatReal(parseFloat(res.data.acrescimo))
          : Helper.formatReal(parseFloat(0));

        commit("setFormaPagamento", formaPagamento);
        commit("setOverlay", false);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  atualizarFormaPagamento: ({ commit }, data) => {
    commit("setOverlay", true);
    FormaPagamentoService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Forma de pagamento atualizado.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar forma de pagamento.");
      });
  },
  excluirFormaPagamento: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    FormaPagamentoService.excluir(data.id)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarError", "Forma de pagamento excluída.");
        dispatch("setModalExcluirFormaPagamento", false);
      })
      .catch((e) => {
        console.log(e);
        commit("snackbarError", "Erro ao excluir forma de pagamento.");
        commit("setOverlay", false);
      });
  },
  setModalExcluirFormaPagamento: ({ commit }, status) => {
    commit("setModalExcluirFormaPagamento", false);
    setTimeout(() => {
      commit("setModalExcluirFormaPagamento", status);
    }, 100);
  },
};

export default {};
